import styled, { css } from 'styled-components';

import { COLORS, STYLES } from 'apps/web_forms/utils/constants';

export const StyledForm = styled.form`
  padding: 0 1em 2em 1em;
  line-height: 1;

  button {
    outline: none;
  }


  ${({ hide }) => hide && css`
    visibility: hidden;
  `}

`;

export const StyledFormControl = styled.div`
  margin-top: 1em;
  min-height: 50vh;
  .react-form-control {
    display: flex;
    flex-direction: column;
    padding: 1em 0;
    margin-bottom: 0.5em;
    border-bottom: 1px solid ${COLORS.borderGrey};

    &.inactive {
      display: none;
    }

    &:empty {
      border-bottom: none;
      padding: 0;
    }

    label {
      font-size: 0.95em;
      font-weight: 300;
      margin-bottom: 0.5em;
      color: black;
      &.boolean-label {
        font-size: 0.9em;
        margin-bottom: 0;
      }
    }

    textarea {
      padding-top: 0.5em;
      min-height: 5em;
      &:active,
      &:focus {
        outline: none;
        border: 1px solid ${COLORS.green};
      }
    }

    input.read-only,
    textarea.read-only,
    select:disabled {
      opacity: 1;
      background-color: ${COLORS.readOnlyInputBackgroundColor};
      &:active,
      &:focus {
        border: 1px solid ${COLORS.borderBooleanRadio};
      }
    }
    .group-container {
      input {
        background-color: white;
        &.read-only {
          background-color: ${COLORS.inputGroupsBackgroundColor};
        }
      }
      input[type='radio'],
      input[type='checkbox'] {
        background-color: white;
        &:checked {
          background-color: ${COLORS.green};
        }
        &.read-only {
          background-color: ${COLORS.inputGroupsBackgroundColor};
          &:active {
            border: 1px solid ${COLORS.borderBooleanRadio};
          }
        }
      }
    }
    input:active,
    input:focus {
      border: 1px solid ${COLORS.green};
      outline: none;
    }
    input:invalid,
    input.invalid,
    textarea.invalid {
      outline: none;
      border: ${STYLES.ErrorHighlight};
      box-shadow: none;
    }
    input.updateHighlight,
    textarea.updateHighlight {
      outline: none;
      border: ${STYLES.UpdateHighlight};
      box-shadow: none;
    }
  }

  input,
  select,
  textarea {
    font-weight: 400;
    font-size: 0.8em;
    font-family: 'Helvetica', 'Roboto';
    border: 1px solid ${COLORS.borderGrey};
    height: 2.5em;
    padding: 0.1em 0.5em 0;
    box-sizing: border-box;
    background-color: ${COLORS.inputBackgroundColor};
    &.error {
      border: ${STYLES.ErrorHighlight};
    }
  }
`;
